/* note: this file cannot be named "config" due to an unexplainable NODE_PATH + webpack bug */

// local
import packageJson from '../package.json';

const CLIENT_ID = process.env.CLIENT_ID || 'nike.valiantlabs.rapid-validation-web';
const ISSUER = process.env.ISSUER || 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7';
const OKTA_TESTING_DISABLEHTTPSCHECK = process.env.OKTA_TESTING_DISABLEHTTPSCHECK || false;
const BASENAME = process.env.PUBLIC_URL || '';


const REDIRECT_URI = `${window.location.origin}${BASENAME}`;
console.log('ORIG_REDIRECT_URI: ', REDIRECT_URI);


const HOSTS: { [key: string]: any } = {
  development: 'https://console.platform.test.vl.nikecloud.com/',
  production: 'https://console.platform.vl.nikecloud.com/'
};

console.log('ISSURE: ', process.env.ISSUER);

const config = {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK
  }
};

export default config;
